/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.strings.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class ApplicationString(
    @SerialName("id")
    val id: Int?,

    @SerialName("key")
    val key: String?,

    @SerialName("string")
    val string: String?,

    @SerialName("created_at")
    val createdAt: String?
)
